<div class="logged-out-footer" *ngIf="!(userAuthenticated$ | async)">
  <h2 class="col-lg-4 col-md-8 col-sm-12">{{ (customVariables$ | async).customfooter_left_title }}</h2>
  <global-footer [dcrCookieLanguage]="dcrCookieLanguage"></global-footer>
</div>

<div class="footer-container" *ngIf="userAuthenticated$ | async">
  <div class="container footer">
    <div class="content-wrapper">
      <h2>{{ (customVariables$ | async).customfooter_left_title }}</h2>
      <div
        *ngFor="let child of (footerSection$ | async)?.content?.children"
        class="footer-content"
        [innerHTML]="child?.body"
      ></div>
    </div>
    <div class="links-wrapper">
      <h2>{{ (customVariables$ | async).customfooter_right_title }}</h2>
      <div class="links">
        <section class="sitemap-links">
          <ng-container *ngFor="let link of mainNavLinks$ | async">
            <a
              href
              *ngIf="link.isVisible"
              role="link"
              tabindex="0"
              [attr.aria-label]="link.ariaLabel"
              [routerLink]="[link.routerLink]"
              class="footer__menu__a"
              (accessibleClick)="navigate(link.routerLink)"
            >
              {{ link.customName ? link.customName : (link.translate | translate) }}</a
            >
          </ng-container>
        </section>
        <section class="hygiene-links-section">
          <a
            href
            aria-label="my preferences"
            role="link"
            tabindex="0"
            [routerLink]="['/preferences']"
            class="footer__menu__a"
            (accessibleClick)="navigate('/preferences')"
          >
            {{ (customVariables$ | async).customfooter_right_list_1 }}
          </a>
          <a
            href
            aria-label="my profile"
            role="link"
            tabindex="0"
            [routerLink]="['/member']"
            class="footer__menu__a"
            (accessibleClick)="navigate('/member')"
          >
            {{ (customVariables$ | async).customfooter_right_list_2 }}
          </a>

          <ng-container *ngFor="let menu of secondaryMenuList$ | async">
            <a
              *ngIf="menu.isVisible"
              href
              role="link"
              tabindex="0"
              class="footer__menu__a"
              [routerLink]="menu.routerLink"
              (accessibleClick)="navigate(menu.routerLink)"
            >
              {{ menu?.customName ? menu?.customName : (menu.translate | translate) }}
            </a>
          </ng-container>
        </section>
      </div>
    </div>
  </div>
  <div
    class="recaptcha-wrapper"
    [ngClass]="{ 'd-none': (siteSettings$ | async)?.switches?.custom_footer_design }"
    *ngIf="isReCaptchaFooter$ | async"
    tabindex="0"
  >
    <div
      *ngFor="let child of (reCaptchaSection$ | async)?.content?.children"
      class="recaptcha"
      [innerHTML]="child?.body"
      tabindex="0"
    ></div>
  </div>
</div>
